import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthPage() {
    const [mode, setMode] = useState("login");
    const [form, setForm] = useState({ full_name: "", email: "", password: "" });
    const [busy, setBusy] = useState(false);
    const { setToken, setUser } = useAuth();
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const url = mode === "login" ? `${API}/auth/login` : `${API}/auth/register`;
            const body = mode === "login"
                ? { email: form.email, password: form.password }
                : form;
            const { data } = await axios.post(url, body);
            setToken(data.token);
            setUser(data.user);
            toast.success(mode === "login" ? "Bienvenue !" : "Compte créé.");
            nav("/mon-espace");
        } catch (err) {
            const d = err.response?.data?.detail;
            toast.error(typeof d === "string" ? d : "Erreur, réessayez.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="auth-page" className="min-h-screen bg-[#FAF9F6]">
            <Navbar />
            <main className="pt-32 pb-24">
                <div className="max-w-md mx-auto px-6">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">Espace client</span>
                    </div>
                    <h1 className="font-serif-lux text-4xl md:text-5xl mb-8">
                        {mode === "login" ? "Se " : "Créer un "}<em className="italic text-[#B89C6A]">{mode === "login" ? "connecter" : "compte"}</em>.
                    </h1>

                    <div className="flex gap-2 mb-8">
                        {["login", "register"].map((m) => (
                            <button key={m} onClick={() => setMode(m)}
                                data-testid={`auth-mode-${m}`}
                                className={`flex-1 py-3 border tracking-luxe transition ${mode === m ? "border-[#B89C6A] bg-[#B89C6A]/10" : "hairline"}`}>
                                {m === "login" ? "Connexion" : "Inscription"}
                            </button>
                        ))}
                    </div>

                    <form onSubmit={submit} className="space-y-6">
                        {mode === "register" && (
                            <input data-testid="auth-name" className="lux-input" required placeholder="Nom et prénom"
                                value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
                        )}
                        <input data-testid="auth-email" type="email" className="lux-input" required placeholder="Email"
                            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                        <input data-testid="auth-password" type="password" className="lux-input" required minLength={6}
                            placeholder="Mot de passe (6 caractères min)"
                            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                        <button type="submit" data-testid="auth-submit" disabled={busy}
                            className="btn-champagne w-full justify-center disabled:opacity-50">
                            {busy ? "…" : mode === "login" ? "Se connecter" : "Créer mon compte"}
                        </button>
                    </form>

                    <div className="mt-8 text-center">
                        <Link to="/" className="text-[12px] tracking-luxe text-[#1C1E1D]/50 hover:text-[#B89C6A]">
                            ← Retour à l'accueil
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
